up.migrate = {
    config: {},
};
